export default __webpack_public_path__ + "static/media/online-study.f6b2d0f6.jpg";